import { useEffect, useState } from "react";
import {
  __EventDispatcher,
  __ProxiProvider,
  __Store,
  __UrlParams,
} from "../../../_core/core";
import "./Draw.history.styles.css";
import { TicketIcon } from "../icons/Ticket";
import { connect } from "react-redux";
import { EventClass, EventType } from "../../config/Events";

const DrawHistory = (_props: any) => {
  const [displayHistory, setDisplayHistory] = useState<boolean>(false);
  const [displayInfo, setDisplayInfo] = useState<boolean>(false);
  const [showFailedBtn, setShowFailedBtn] = useState<boolean>(false);

  const onFailedBtnPress = () => {
    __EventDispatcher.dispatch(
      EventClass.GUI,
      EventType.GUI.SHOW_FAILED_BETS,
      true
    );
  };

  useEffect(() => {
    if (__UrlParams.props.historyURL) {
      setDisplayHistory(true);
    }
    if (__UrlParams.props.rulesURL) {
      setDisplayInfo(true);
    }
    const { game } = __Store.getState();
    if (game.SESSION_DATA.currency.code === "FUN") {
      setDisplayHistory(false);
    }
  }, []);

  useEffect(() => {
    if (_props.failedBets && _props.failedBets.length > 0) {
      setShowFailedBtn(true);
    }
  }, [_props.failedBets]);

  return (
    <div className="historyRules">
      {displayHistory ? (
        <button
          className="btn-weird btn-history"
          onClick={() => __ProxiProvider.visitHistory()}
        ></button>
      ) : (
        ""
      )}
      {displayInfo ? (
        <button
          className="btn-weird btn-info"
          onClick={() => __ProxiProvider.visitRules()}
        ></button>
      ) : (
        ""
      )}
      {showFailedBtn ? (
        <button
          className="keno-failed-bets__btn"
          onClick={() => onFailedBtnPress()}
        >
          <TicketIcon />
        </button>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    failedBets: state.game.GAMEPLAY.failedBets,
  };
};

export default connect(mapStateToProps, {})(DrawHistory);
